/**
 * Parse resolution TEXT from API: legacy plain string or JSON version history.
 * Latest version uses `body` (may be null for note-free closes).
 */
export function parseNpsResolution(resolutionRaw) {
  if (resolutionRaw === undefined || resolutionRaw === null) {
    return { format: 'empty' };
  }

  const str = String(resolutionRaw).trim();
  if (!str) {
    return { format: 'empty' };
  }

  if (str.startsWith('{') || str.startsWith('[')) {
    try {
      const parsed = JSON.parse(str);
      const versions = Array.isArray(parsed)
        ? parsed
        : parsed.versions || parsed.history || parsed.entries;

      if (Array.isArray(versions) && versions.length > 0) {
        const latest = versions[versions.length - 1];
        const body = latest.body ?? latest.note ?? latest.text ?? null;
        const hasBody = body != null && String(body).trim() !== '';

        return {
          format: hasBody ? 'versioned' : 'empty_latest',
          body: hasBody ? String(body).trim() : null,
          at: latest.at ?? latest.date ?? latest.created_at ?? null,
          by: latest.by ?? latest.resolved_by ?? null,
        };
      }
    } catch {
      // fall through to legacy plain text
    }
  }

  return {
    format: 'legacy',
    body: str,
    at: null,
    by: null,
  };
}

/** What to show on a resolved card (never when unresolved). */
export function getNpsResolutionDisplay(item) {
  if (!item) return { mode: 'none' };

  const parsed = parseNpsResolution(item.resolution);

  if (parsed.format === 'versioned' || parsed.format === 'legacy') {
    return {
      mode: 'note',
      body: parsed.body,
      at: parsed.at || item.resolved_at,
      by: parsed.by || item.resolved_by,
    };
  }

  return {
    mode: 'marked_complete',
    at: item.resolved_at,
    by: item.resolved_by,
  };
}
